import { Component, input } from '@angular/core';

/**
 * The capelo from the brand material, plus the wordmark. Same drawing as
 * public/favicon.svg, so the tab and the product show one mark.
 */
@Component({
    selector: 'app-brand-mark',
    template: `
        <span class="brand-mark" [style.--brand-mark-size.px]="size()">
            <svg class="brand-mark__symbol" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
                <rect width="64" height="64" rx="13" fill="var(--app-brand-mark-plate, #ffffff)"></rect>
                <g fill="var(--app-brand-mark-ink, #2439a4)" transform="translate(32 33) scale(0.78) translate(-32 -31)">
                    <path d="M32 6 62 23 32 40 2 23z"></path>
                    <path d="M14 29v16l18 10 4-2.3V38.2L32 36l-8-4.6z"></path>
                    <path d="M50 29v16l-6 3.4V32.4z"></path>
                    <path d="M44 50.6 50 47.2v9L47 58l-3-1.7z"></path>
                </g>
            </svg>

            @if (showWordmark()) {
                <span class="brand-mark__wordmark">Hub Escolar</span>
            }
        </span>
    `,
    styles: `
        .brand-mark {
            display: inline-flex;
            align-items: center;
            gap: 0.625rem;
        }

        .brand-mark__symbol {
            width: var(--brand-mark-size);
            height: var(--brand-mark-size);
            flex: none;
        }

        .brand-mark__wordmark {
            font-size: 1rem;
            font-weight: 700;
            letter-spacing: -0.01em;
            white-space: nowrap;
        }
    `
})
export class BrandMarkComponent {
    readonly size = input(32);
    readonly showWordmark = input(true);
}
